import React from "react";
import cn from "classnames";
import Button from "./Button";

const MenusItem = ({ className, menuList, param, setParam }) => {

  return (
    <div className={cn("menu", className)}>
      {menuList.map((item, index) =>
        <Button
          item={item}
          param={param}
          setParam={setParam}
          key={index} />
      )}
    </div>
  )
}

export default MenusItem;